import { Button } from 'devextreme-react';
import { Column, Item, Toolbar } from 'devextreme-react/data-grid';
import { PageSize } from 'devextreme-react/diagram';
import Tooltip from 'devextreme-react/tooltip';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import DatagridCustom from '../../components/common/datagrid/custom-datagrid';
import ExportButton from '../../components/ui/ExportButton.jsx';
import RefreshButton from '../../components/ui/RefreshButton.jsx';
import api from '../../services/api-configuration';
import useFormatMessage from '../../utils/useFormatMessage';

function VeriTakibi() {

    const { t } = useFormatMessage()
    const dataGridRef = useRef(null)
    const [dataSource, setDataSource] = useState();
    const [downloadingFile, setDownloadingFile] = useState([]);
    const [downloadingReport, setDownloadingReports] = useState([])
    const notifyError = (message) => toast.error(`${message}`);
    const pagesize = 10;



    useEffect(() => {
        getDataSource()
    }, [])

    const getDataSource = async () => {
        if (dataGridRef?.current?.instance) dataGridRef.current.instance.beginCustomLoading(`${t("Yükleniyor")}...`);
        try {
            const response = await api.post("/getAllFileTrackings", {
                "end_date": null,
                "file_type": null,
                "process_type": null,
                "start_date": null,
                "user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
            });
            if (response.data.data == null) {
                toast.warn("Veri Bulunamamıştır")
            }
            if (dataGridRef?.current?.instance) await dataGridRef.current.instance.endCustomLoading();
            setDataSource(response.data.data || []);
        } catch (error) {
            //TODO: Hata mesajını göster
            console.error("Tüm veriler getirilemedi.", error);
            notifyError(error.response.data.message);
            console.error("Tüm Veriler Getirilemedi.");
        }
    }




    const handleDownload = async (data, BASE_URL) => {
        const fileName = data.file_name || "dosya.xlsx";
        const fileID = data.id

        const isFileDownload = BASE_URL === "/downloadFile";
        const isReportDownload = BASE_URL === "/downloadReport";

        if (isFileDownload && downloadingFile.includes(fileID) || isReportDownload && downloadingReport.includes(fileID)) {
            return;
        }



        if (isFileDownload) {
            setDownloadingFile(prev => [...prev, fileID]);

        } else if (isReportDownload) {
            setDownloadingReports(prev => [...prev, fileID]);
        }


        try {
            const response = await api.post(BASE_URL,
                { "id": fileID },
                {
                    responseType: 'blob',
                    headers: {
                        'Accept': 'application/octet-stream',
                        'Content-Type': 'application/json'
                    }
                }
            );

            // Dosya içeriğini al
            const blob = new Blob([response.data]);

            // Dosyayı indir
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();

            // Temizlik
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error("Dosya indirme hatası:", error);
            if (error.response) {
                notifyError(error.response.data?.message || "Dosya indirilemedi");
            } else {
                notifyError("Dosya indirme işlemi başarısız oldu");
            }
        } finally {
            if (isFileDownload) {
                setDownloadingFile(prev => prev.filter(id => id !== fileID));
            } else if (isReportDownload) {
                setDownloadingReports(prev => prev.filter(id => id !== fileID));
            }
        }
    }





    return (
        <div>
            <Breadcrumb current={t("Veri Takibi")} />
            <Card className='p-4'>

                <PageSize defaultPageSize={pagesize} />

                <DatagridCustom
                    dataSource={dataSource}
                    keyExpr="id"
                    reff={dataGridRef}
                    showBorders={true}
                >
                    <PageSize defaultPageSize={pagesize} />

                    <Toolbar>
                        <Item>
                            <RefreshButton onClick={getDataSource} />
                        </Item>
                        <Item>
                            <ExportButton
                                refValue={dataGridRef}
                                title='Veri Takibi'

                            />

                        </Item>
                    </Toolbar>
                    <Column
                        caption={t("Dosyayı İndir")}
                        alignment='center'
                        allowExporting={false}
                        cellRender={({ data }) => (
                            <Button onClick={() => handleDownload(data, "/downloadFile")} disabled={downloadingFile.includes(data.id)} >{downloadingFile.includes(data.id) ? "İndiriliyor..." : t("İndir")}</Button>
                        )}
                    />

                    <Column dataField="file_name" alignment='center' caption={t("Dosya Adı")} />
                    <Column dataField="username" alignment='center' caption={t("Kullanıcı Adı")} />
                    <Column dataField="upload_date" alignment='center'
                        calculateDisplayValue={(data) => {
                            return data.upload_date ? moment.utc(data.upload_date).format("DD/MM/YYYY HH:mm") : "";
                        }}
                        sortIndex={0} sortOrder={"desc"} width={"200px"} caption={t("Yükleme Tarih")} />
                    <Column dataField="total_records" alignment='center' caption={t("Şase Sayısı")} />
                    <Column dataField="success_count" alignment='center' caption={t("Başarılı")} />
                    <Column dataField="failure_count" alignment='center' caption={t("Hatalı")} />

                    <Column
                        caption={t("Sonuç Raporu")}
                        alignment='center'
                        allowExporting={false}
                        cellRender={({ data }) => (
                            <Button onClick={() => handleDownload(data, "/downloadReport")} disabled={downloadingReport.includes(data.id)} >{downloadingReport.includes(data.id) ? "İndiriliyor..." : t("İndir")}</Button>
                        )}
                    />
                    <Column dataField="warning_count" alignment='center' caption={t("Uyarılı")}
                        width={"75"}
                        headerCellRender={() => {
                            return (<>
                                <i className='fa fa-info-circle mr-1'
                                    style={{ color: "white" }} id='warning-icon'></i>
                                <span>Uyarılı</span>
                                <Tooltip
                                    target='#warning-icon' showEvent="mouseenter"
                                    hideEvent="mouseleave"
                                    position={{
                                        my: "bottom",
                                        at: "top",
                                        of: "#warning-icon"
                                    }}
                                    hideOnOutsideClick={false} >
                                    <div>
                                        Uyarılı kayıtlar, başarılı kayıttır.
                                        Fakat kullanıcıya uyarı verilmiştir.
                                    </div>

                                </Tooltip>
                            </>)
                        }}
                    />
                </ DatagridCustom>

            </Card>
        </div>


    )
}

export default VeriTakibi